var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconStarSolid = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 12,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.342.937 7.91 4.045l3.019.299a.378.378 0 0 1 .234.644L8.68 7.45l.92 3.346a.381.381 0 0 1-.539.439L6 9.719l-3.056 1.514a.381.381 0 0 1-.54-.439l.921-3.346L.84 4.986a.377.377 0 0 1 .234-.644l3.02-.3L5.657.938a.384.384 0 0 1 .684 0"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 12,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.342.937 7.91 4.045l3.019.299a.378.378 0 0 1 .234.644L8.68 7.45l.92 3.346a.381.381 0 0 1-.539.439L6 9.719l-3.056 1.514a.381.381 0 0 1-.54-.439l.921-3.346L.84 4.986a.377.377 0 0 1 .234-.644l3.02-.3L5.657.938a.384.384 0 0 1 .684 0"
  }));
});
export default SvgIconStarSolid;
export const raw = __webpack_public_path__ + "static/media/IconStarSolid.6d606720a98bb3ab971884acd82958a0.svg";